const RENT_VS_BUY_DEFAULT_VALUES = {
  purchasePrice: 3e5,
  downPaymentPercent: 10,
  monthlyRent: 1800,
  initialHomeAppreciationRate: 2.7,
  investmentReturnRate: 6,
  propertyTaxRate: 1.11,
  maintenanceCostsPercent: 0.5,
  purchaseCostsPercent: 3,
  hoaDues: 50,
  homeownersInsurancePercent: 0.5,
  interestRate: 3,
  mortgageRate: 5.7,
  renovationCostsPercent: 0.5,
  rentBrokerFee: 0,
  rentingUtilities: 150,
  rentersInsuranceRate: 0.7,
  marginalTaxRate: 25,
  sellingCostsPercent: 8,
  initialRentAppreciationRate: 4.6,
  loadingUserResponses: true,
  loadingLocationData: true,
  scrubberLine: 3,
  chartLayout: {
    padding: {
      left: 0,
      right: 35
    }
  }
};
var RentVsBuyVariables = /* @__PURE__ */ ((RentVsBuyVariables2) => {
  RentVsBuyVariables2["PurchasePrice"] = "purchasePrice";
  RentVsBuyVariables2["DownPaymentPercent"] = "downPaymentPercent";
  RentVsBuyVariables2["MonthlyRent"] = "monthlyRent";
  RentVsBuyVariables2["InitialHomeAppreciationRate"] = "initialHomeAppreciationRate";
  RentVsBuyVariables2["InitialRentAppreciationRate"] = "initialRentAppreciationRate";
  RentVsBuyVariables2["InvestmentReturnRate"] = "investmentReturnRate";
  RentVsBuyVariables2["MortgageRate"] = "mortgageRate";
  RentVsBuyVariables2["HoaDues"] = "hoaDues";
  RentVsBuyVariables2["PropertyTaxRate"] = "propertyTaxRate";
  RentVsBuyVariables2["MaintenanceCostsPercent"] = "maintenanceCostsPercent";
  RentVsBuyVariables2["PurchaseCostsPercent"] = "purchaseCostsPercent";
  RentVsBuyVariables2["SellingCostsPercent"] = "sellingCostsPercent";
  RentVsBuyVariables2["MarginalTaxRate"] = "marginalTaxRate";
  RentVsBuyVariables2["RentBrokerFee"] = "rentBrokerFee";
  RentVsBuyVariables2["RentersInsuranceRate"] = "rentersInsuranceRate";
  RentVsBuyVariables2["RentingUtilities"] = "rentingUtilities";
  RentVsBuyVariables2["RenovationCostsPercent"] = "renovationCostsPercent";
  RentVsBuyVariables2["HomeownersInsurancePercent"] = "homeownersInsurancePercent";
  return RentVsBuyVariables2;
})(RentVsBuyVariables || {});
export {
  RENT_VS_BUY_DEFAULT_VALUES,
  RentVsBuyVariables
};
